import React from 'react';
import createForm from "../Form";
import ComponentField from "../../../form/ComponentField";
import DateTimeInput from "../../../form/DateTimeInput";
import CheckBox from "../../../form/CheckBox";
import Select from "../../../form/Select";
import TextInput from '../../../form/TextInput';

class LoyaltyPointWalletForm extends React.Component {

    render() {
        const filterProps = {
            name: "filter",
            value: typeof this.props.values.filter === "string" ? JSON.parse(this.props.values.filter) : this.props.values.filter,
            saveChanges: this.props.setFieldValue
        };
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("user")}
                            disabled="disabled"
                            name="name"
                            value={(this.props.values.user || {}).name}
                            label="Tulajdonos neve"
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("user")}
                            disabled="disabled"
                            name="email"
                            value={(this.props.values.user || {}).email}
                            label="Tulajdonos e-mail-címe"
                        />
                    </div>
                    {/* <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("expiry")}
                            isClearable={true}
                            name="expiry"
                            value={this.props.values.expiry}
                            label="Lejárat"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                            disabled={true}
                        />
                    </div> */}
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="original_amount"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Összesen gyűjtött pontszám"
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="cleared_amount"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Beváltott pontszám"
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="expired_amount"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Lejárt pontszám"
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="amount"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Aktuális egyenleg"
                            disabled={true}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(LoyaltyPointWalletForm);
